export async function AuthGuard() {
  const token = localStorage.getItem("userToken"), userProfile: any = JSON.parse(localStorage.getItem("userProfile") || '{}');
  if (token && userProfile.entity_id) {
    return true;
  } else {
    return {path: 'connexion', replace: true};
  }
}
